import { useMutation, useQueryClient } from '@tanstack/react-query';
import { couponService, type GoodsOption } from 'shared/src/api';
import { useGoodsOptionsPricing } from './useGoodsOptionsPricing';
import { isNil } from 'shared/src/utils';
import { useGoodsSno } from '../../../hooks/useGoodsSno';
import { queryKey } from '../../../constant/queryKey';

export const usePostBatchRedeemCoupon = (selected: GoodsOption[]) => {
  const client = useQueryClient();
  const sno = useGoodsSno();

  const { data: pricing } = useGoodsOptionsPricing({
    options: selected.map(option => ({
      sno: option.sno,
      count: option.purchase_count ?? 1,
    })),
  });

  return useMutation({
    mutationFn: async () => {
      if (isNil(pricing)) return null;
      const downloadableCoupons = pricing.coupon_list.filter(
        coupon => !coupon.item.is_issued,
      );

      if (downloadableCoupons.length === 0) return null;

      return couponService.postBatchRedeemCoupons({
        coupon_snos: downloadableCoupons.map(coupon => coupon.item.sno),
      });
    },
    throwOnError: false,
    onSuccess: () => {
      client.invalidateQueries({
        queryKey: queryKey.goodsOptionsPricing(sno),
      });
    },
  });
};
